import { type FC } from 'react';

import ArrowBackIcon from '@/assets/svg/ui-elements/arrow-back.svg';

import { theme } from '../../theme';
import Typography from '../Typography';
import { ArrowBox, IconBox, StyledOptionCard, TextBlock, TitleRow } from './styled';
import type { OptionCardProps } from './types';

const OptionCard: FC<OptionCardProps> = ({ icon, title, subtitle, badge, ...rest }) => (
  <StyledOptionCard {...rest}>
    <IconBox>{icon}</IconBox>

    <TextBlock>
      <TitleRow>
        <Typography variant="body1" fontWeight={600}>
          {title}
        </Typography>
        {badge}
      </TitleRow>

      {subtitle && (
        <Typography variant="body3" color={theme.colors.text.secondary}>
          {subtitle}
        </Typography>
      )}
    </TextBlock>

    <ArrowBox aria-hidden>
      <ArrowBackIcon transform="rotate(180)" />
    </ArrowBox>
  </StyledOptionCard>
);

OptionCard.displayName = 'OptionCard';

export default OptionCard;
